import { Component, Input, OnInit } from "@angular/core";
import { DContextoMuisca } from "@dian/core";
import { DContextoUsuarioServicio } from "@dian/api-identidad";

@Component({
  selector: "app-info-sesion",
  templateUrl: "./infoSesion.component.html",
  styleUrls: ["./infoSesion.component.css"],
  providers: [],
})
export class InfoSesionComponent implements OnInit {
  @Input() titulo: string;
  @Input() datosUsuario: DContextoMuisca;
  private tiempo: Date;
  constructor(private dContextoUsuarioServicio: DContextoUsuarioServicio) {
    this.tiempo = new Date();
    let tiempoReal = new Date();
    setInterval(() => {
      tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
      this.tiempo = new Date(tiempoReal);
    }, 1000);
  }

  ngOnInit() {}
  /**
   * @desc Función para redireccionar a un link especifico de Muisca
   */
  public hrefButton(href: string) {
    window.location.href = location.origin + href;
  }

  /**
   * @desc Función para hacer el logout de la aplicación
   */
  public logoutApp() {
    this.dContextoUsuarioServicio.logOut();
  }

  formatearMes(mes:number){
      const arrayMes = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
      return arrayMes[mes-1];
    
  
  }
}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/shared/InfoSesion/infoSesion.component.ts